import React, { useContext } from 'react'
import View from '../../atoms/View'
import { ItemContext } from 'src/contexts/itemContext'

import Text from 'src/components/atoms/TextNew'
import DownloadPdfSvg from 'src/components/other/svg/DownloadPdfSvg'

const InvoiceRightColumn = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  return (
    <View className="flex flex-col rounded-l-2 justify-center items-center shadow-insetSmall w-[100px]">
      <DownloadPdfSvg className="w-14 h-14" svgStyles="w-14 h-14" />
      <Text className="text-l">{itemContext.display_number}</Text>
    </View>
  )
}

export default InvoiceRightColumn
